module.exports = __webpack_public_path__ + "static/media/splash3.e835a7b9.jpg";